<template>
  <!--课程详情-->
  <div class="box">
    <div>
      <img class="course—pic" :src="row.pic_url" alt v-if="!paly_show" />
      <video width="100%" controls ref="videos" v-else>
        <source  id="playVideosss" :src="play_url" />
      </video>
    </div>
    <van-tabs v-model="active" animated class="active-tab" sticky title-active-color="#000">
      <van-tab v-for="(item,index) in activeTab" :key="index">
        <template #title>
          <!-- <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span> -->
          {{item.name}}
        </template>
        <div class="directory" v-if="active==0">
          <van-steps
            direction="vertical"
            :active="videoActive"
            active-icon="checked"
            inactive-icon="circle"
          >
            <van-step v-for="(item,i) in row.items" :key="i">
              <p class="course-title" @click="onPlayItems(i)">{{ item.title }}</p>
              <p class="course-info" @click="onPlayItems(i)">{{item.views_count}}人播放</p>
            </van-step>
          </van-steps>
          <div v-if="row.items.length==0">
            <van-empty description="暂时还没上传视频!" />
          </div>
        </div>
        <div class="course-detail" v-if="active==1">
          <div class="course-title-box">
            <div class="course-detail-title">{{row.title}}</div>
            <div class="course-detail-info" v-if="row.need_pay=='1'">免费</div>
            <div class="course-detail-info" v-else>
              <span class="course-price">¥{{row.price}}</span>
              <span class="course-validity">有效期 {{row.pay_days}}天</span>
            </div>
            <div class="course-play">
              <span class="course-num">视频 {{row.items.length}}</span>
              <span class="course-play-num">播放{{row.views_count}}</span>
            </div>
          </div>
          <div class="course-content">
            <div class="course-content-title">课程介绍</div>
            <!-- <div v-html=""></div> -->

            <div class="content html-data" v-html="row.content">
              <!-- {{ row.content }} -->
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 底部付费 -->
    <div class="course-bottom" v-if="row.need_pay=='2'">
      <div
        style="display: flex;justify-content: space-between;align-items: center;padding:0 10px;height:62px"
      >
        <div style="display: flex;align-items: center;">
          <span class="bottom-course">课程</span>
          <span class="bottom-course-price">¥{{row.price}}</span>
        </div>
        <div class="course-pay" @click="onPlayShwo">立即购买</div>
      </div>
    </div>
    <van-overlay :show="pay_show" @click="pay_show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div style="flex: 1;display: flex; justify-content: center;flex-direction: column;">
            <p>本视频需要付费开通</p>
            <p>您可以选择在线支付或者使用激活卡</p>
          </div>
          <div class="pay-show-bottom">
            <span class="no-pay" @click="pay_show=false">不看了</span>
            <span class="on-pay" @click="onPlayShwo">立即开通</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<style scoped>
.course—pic {
  width: 100%;
}
.no-pay {
  width: 1.5rem;
  height: 0.5rem;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 0.5rem;
  text-align: center;
  margin-right: 15px;
}
.on-pay {
  width: 1.5rem;
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 13px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
  margin-left: 15px;
}
.pay-show-bottom {
  width: 100%;
  height: 1.2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.block p {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  text-align: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 6.1rem;
  height: 3.55rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  /* align-items: center; */
}
.bottom-course-price {
  height: 30px;
  font-size: 21px;
  font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: rgba(255, 71, 104, 1);
  line-height: 30px;
  margin-left: 10px;
}
.bottom-course {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(17, 17, 17, 1);
  line-height: 20px;
}
.course-pay {
  width: 3.1rem;
  height: 44px;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 22px;
  font-size: 14px;
  font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 44px;
}
.course-bottom {
  width: 100%;
  height: 62px;
  background: rgba(255, 255, 255, 1);
  position: fixed;
  bottom: 0;
}
.content {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 30px;
  text-indent: 28px;
}
.course-content-title {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 20px;
  /* padding-left: 10px; */
}
.course-content {
  margin-top: 20px;
  border-radius: 10px 10px 0 0;
  background: #fff;
  padding: 10px 10px;
  padding-bottom: 50px;
  margin-bottom: 50px;
}
.course-title-box {
  border-radius: 0 0 10px 10px;
  background: #fff;
  padding: 10px 0.2rem;
}
.course-detail-title {
  height: 21px;
  font-size: 15px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
}
.course-detail-info {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.course-detail-info .course-price {
  font-size: 16px;
  font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}
.course-detail-info .course-validity {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-left: 10px;
}
.course-play {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  height: 38px;
  /* opacity:0.08; */
}
.course-num,
.course-play-num {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.course-detail {
  /* width: 7.1rem; */
  margin: 0px auto;
}
.active-icon {
  background: red;
}
.course-info {
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 0.85);
}
.course-title {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
}
.directory {
  width: 6.9rem;
  margin: 10px auto;
  padding-left: 10px;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
}
.box {
  /*margin-bottom: 1.5rem;*/
  background: #f8f8f8;
  height: 100%;
}
.box >>> .van-tabs__line {
  background: #00b388;
}
</style>
<script>
import Vue from "vue";
import {
  Tab,
  Tabs,
  List,
  PullRefresh,
  Toast,
  Step,
  Steps,
  Overlay,
  Empty
} from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast)
  .use(Step)
  .use(Steps)
  .use(Overlay)
  .use(Empty);
export default {
  name: "CourseDetail",
  components: {},
  data: function() {
    return {
      active: 0,
      activeTab: [
        { name: "目录", num: 0 },
        { name: "介绍", num: 0 }
      ],
      pay_show: false,
      paly_show: false,
      course_id: 0,
      videoActive: 0,
      row: {
        items: []
      },
      play_url: ""
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "课程详情";
    that.course_id = this.$route.query.id;
    that.getCourseDetail();
    that.videoActive = localStorage.getItem("videoActive") || 0;
    that.setBrowse()
  },
  watch: {},
  destroyed() {},
  methods: {
    // toOrderCheck() {  
    //   rblink({ name: "CourseOrderCheck", query: { id: that.course_id } });
    // },
    setBrowse(){
      let arr=JSON.parse(localStorage.getItem('browseIds')) || []
        arr.map((item,i)=>{
          if(item==this.course_id){
            arr.splice(i,1)
          }
        })
          arr.push(this.course_id) 
        localStorage.setItem('browseIds',JSON.stringify(arr))
    },
    onPlayItems(i) {
      console.log(i);
      if (this.row.need_pay == "2") {
        this.pay_show = true;
        return;
      }
      this.videoActive = i;
      this.paly_show = false;
      this.play_url = this.row.items[i].video_url;
      localStorage.setItem("videoActive", i);

      this.$api.post(
        "/api/course/courseItemsViewsCountAdd",
        { id: this.row.items[i].id },
        res => {
          console.log(res);
          this.row.items[i].views_count += 1;
          this.paly_show = true;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    getCourseDetail() {
      let that = this;
      this.$api.get(
        "/api/course/detail",
        { id: that.course_id },
        res => {
          console.log(res);
          that.row = res.data;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    onPlayShwo() {
      // this.pay_show = true;
      let that=this
      rbLink({ name: "CourseOrderCheck", query: { id: that.course_id } });

    }
  }
};
</script>



// WEBPACK FOOTER //
// CourseDetail.vue?3779b041